<div *ngIf="!isLoading" >
  <mat-card class="fuse-card-large" style="min-height: 365px;margin: 0px;">
    <mat-card-header>
        <mat-card-title translate>Corsi preferiti</mat-card-title>
    </mat-card-header>
    <div *ngIf="noFavouritesCourses">Non hai salvato corsi preferiti!
    In ogni singola scheda corso/percorso puoi cliccare sull'icona della stella per inserirlo nell'elenco dei tuoi corsi preferiti, così da averlo accessibile velocemente da questa pagina.</div>
    <table mat-table [dataSource]="FavouritesCourses" multiTemplateDataRows matSort class="table-style w-100">
      <ng-container matColumnDef="order">
        <td mat-cell *matCellDef="let index = dataIndex">
          {{ index + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="courseCode">
        <td mat-cell *matCellDef="let element">
          {{ element.CourseCode }}
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row cp" (click)="openCourse()"></tr>
    </table>
</mat-card>


</div>

<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>

